const table = {
  id: "序号"
} 
export default table